import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  DOCUMENT_UPLOAD,
  IMAGE_UPLOAD,
  EXCEL_UPLOAD,
  MEDIA_UPLOAD,
  DOCUMENT_UPLOAD_PUBLIC
} from "./type";

export const documentUploadUrl = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileUpload.docUpload
  );
  if (res) {
    const { data } = res;
    dispatch({ type: DOCUMENT_UPLOAD, payload: data.response.data });
    return data.response.data;
  }
};

export const imageUploadUrl = (data) => async (dispatch) => {
  console.log('imgDtaa', data)
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileUpload.imageUpload
  );
  if (res) {
    const { data } = res;
    dispatch({ type: IMAGE_UPLOAD, payload: data.response.data });
    return data.response.data;
  }
};

export const imageUploadUrlPublic = (data) => async (dispatch) => {
  console.log('imgDtaa', data)
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileUpload.imageUploadPublic
  );
  if (res) {
    const { data } = res;
    dispatch({ type: IMAGE_UPLOAD, payload: data.response.data });
    return data.response.data;
  }
};

export const videoUploadUrl = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileUpload.mediaUpload
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MEDIA_UPLOAD, payload: data.response.data });
    return data.response.data;
  }
};

export const excelUploadUrl = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileUpload.excelUpload
  );
  if (res) {
    const { data } = res;
    dispatch({ type: EXCEL_UPLOAD, payload: data.response.data });
    return data.response.data;
  }
};

export const documentUploadUrlPublic = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileUpload.carnivalDocumentPublic
  );
  if (res) {
    const { data } = res;
    dispatch({ type: DOCUMENT_UPLOAD_PUBLIC, payload: data.response.data });
    return data.response.data;
  }
};
